import { Observable } from 'rxjs';
import {
  ApiResponseModel,
  AuthorizationRequestModel,
  LoginRequestModel,
  TwoFactorAuthorizationRequestModel,
  UserAuthorityModel,
} from '@grabbill/lib';

export interface ResolveTenantRequestModel {
  email: string;
}

export interface TenantInfoModel {
  tenantId: string;
  companyName: string;
}

export abstract class AuthApi {
  abstract login(request: LoginRequestModel): Observable<ApiResponseModel<UserAuthorityModel>>;

  abstract resolveTenants(request: ResolveTenantRequestModel): Observable<ApiResponseModel<TenantInfoModel[]>>;

  abstract authorize(loginRequest: AuthorizationRequestModel): Observable<ApiResponseModel<UserAuthorityModel>>;

  abstract getAuthority(): Observable<ApiResponseModel<UserAuthorityModel>>;

  abstract refreshToken(): Observable<ApiResponseModel<UserAuthorityModel>>;

  abstract twoFactorAuthorization(
    request: TwoFactorAuthorizationRequestModel
  ): Observable<ApiResponseModel<UserAuthorityModel>>;

  abstract logout(): Observable<ApiResponseModel<UserAuthorityModel>>;
}
